module.exports = __webpack_public_path__ + "static/media/project-youtube.a013ac2f.jpg";